var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"news-article"}},[_c('header',[_c('h2',[_vm._v(" "+_vm._s(_vm.data.title)+" ")]),_c('time',[_vm._v(" "+_vm._s(_vm.data.createTime)+" ")])]),_c('section',{domProps:{"innerHTML":_vm._s(_vm.data.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }